import React from "react";
import { RISK_COLORS } from "@/lib/risk";
import { cn } from "@/lib/utils";

/**
 * Horizontal green→yellow→orange→red risk bar with a marker.
 * `position` is a 0-100 percentage.
 */
export function RiskBar({ position, level, label, testid, size = "md" }) {
    const h = size === "sm" ? "h-2" : "h-3";
    const pos = Math.min(100, Math.max(0, position));
    const color = RISK_COLORS[level]?.hex || "#0f172a";
    return (
        <div className={cn("relative w-full rounded-full fw-risk-gradient shadow-inner", h)} data-testid={testid}>
            <div
                className="absolute -top-1.5 -translate-x-1/2"
                style={{ left: `${pos}%` }}
                aria-label={label}
            >
                <div
                    className="h-6 w-1.5 rounded-full shadow-md ring-2 ring-white"
                    style={{ background: color }}
                />
            </div>
        </div>
    );
}

export function MiniRiskBar({ position, level }) {
    const pos = Math.min(100, Math.max(0, position));
    const color = RISK_COLORS[level]?.hex || "#0f172a";
    return (
        <div className="relative h-1.5 w-16 rounded-full fw-risk-gradient overflow-visible">
            <div
                className="absolute -top-1 h-3.5 w-1 rounded-full ring-1 ring-white"
                style={{ left: `${pos}%`, background: color, transform: "translateX(-50%)" }}
            />
        </div>
    );
}
